import axios from '@axios';

const base = '/api/v1/wings';

export default {
  getWings(){
    return axios.get(`${base}/`);
  },
  createWing(wingData){
    return axios.post(`${base}/create`, wingData);
  },
  updateStockCheck(wingId, newStock){
    return axios.post(`${base}/check-stock-change/${wingId}`, newStock);
  },
  updateStock(wingId, newStock){
    return axios.post(`${base}/set-stock/${wingId}`, newStock);
  },
  updateWing(wingId, wingData){
    return axios.post(`${base}/update/${wingId}`, wingData);
  }
};
